const STORAGE_KEY = 'app_unlock_token';
const STORAGE_EXPIRY_KEY = 'app_unlock_expires_at';

/** Read unlock token (migrates legacy sessionStorage entries). */
export function getAppUnlockToken() {
  let token = localStorage.getItem(STORAGE_KEY);
  if (token) return token;

  token = sessionStorage.getItem(STORAGE_KEY);
  if (!token) return null;

  const expiresAt = sessionStorage.getItem(STORAGE_EXPIRY_KEY);
  localStorage.setItem(STORAGE_KEY, token);
  if (expiresAt) localStorage.setItem(STORAGE_EXPIRY_KEY, expiresAt);
  sessionStorage.removeItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_EXPIRY_KEY);
  return token;
}

export function getAppUnlockExpiresAt() {
  return (
    localStorage.getItem(STORAGE_EXPIRY_KEY) ||
    sessionStorage.getItem(STORAGE_EXPIRY_KEY)
  );
}

export function setAppUnlockSession(token, expiresAt) {
  localStorage.setItem(STORAGE_KEY, token);
  localStorage.setItem(STORAGE_EXPIRY_KEY, expiresAt);
  sessionStorage.removeItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_EXPIRY_KEY);
}

export function clearAppUnlockSession() {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(STORAGE_EXPIRY_KEY);
  sessionStorage.removeItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_EXPIRY_KEY);
}

export function isAppUnlockExpired() {
  const expiresAt = getAppUnlockExpiresAt();
  return !expiresAt || new Date(expiresAt) <= new Date();
}
